
import { Component, Vue, Prop } from "vue-property-decorator";

import { FolderStore } from "./interface/FolderStore";
import BotVue from "./BotVue.vue";
import { IFolder, FolderType } from "../../../server/src/ai/interface/IFolder"
import Bus from "@/lib/Bus";
import { IUser } from "../../../server/src/user/IUser";
import { botPrecompiledType, botType, IBot } from "../../../server/src/ai/interface/IBot";
import { DragManager, typeMoveBot, typeSelectBot, typeMoveParam, typeMoveObj, typeCtxParam, typeDatasourceParam } from "./DragManager";
import ContextVue from "./ContextVue.vue"
import UseBotsVue from "./UseBotsVue.vue"
import DatasourceVue from "./DatasourceVue.vue"
import { ICtx } from "../../../server/src/ai/interface/ICtx";

const bus: Bus = new Bus().getBus();


@Component({ components: { BotVue, ContextVue, UseBotsVue, DatasourceVue } })
export default class AIFolderVue extends Vue {
  key = 0;
  prompt_key=0;
  store: FolderStore = FolderStore.getInstance()
  @Prop({ default: undefined, type: Function }) prefresh!: Function | undefined;
  can_see_code = false
  @Prop({ type: String, default: undefined }) parent_id?: string;
  @Prop({ type: Object, default: undefined }) folder: IFolder | undefined;
  username:string=""
  expandedIndex: number | null = null;
  bot_keys:any
  bots_key=0;
  bot_left=10
  btype=botType
  items: IFolder[] | undefined = undefined;
  //converters: IConverter[] =[]
  
  bots: IBot[] =[]
  precompiled_bots: IBot[] =[]
  ctx: {[key:string]:any} = {}
  ctx_key=0;  

 
  mousePosition: { x: number; y: number } = { x: 0, y: 0 };
  lastMousePos: { x: number; y: number } = { x: 0, y: 0 };
  dm=DragManager.getInstance()  

  async mounted() {
    await this.refresh();
  }

  is_selected(b:IBot) {
    const bot=this.dm.get(typeSelectBot)
    if (!bot) return false;
    return (b.id===bot.id)
  }

  get_next_name(item: IFolder, items:IFolder[]) {
    if (!items) return "";
    let max = 0;
    let exists = false;
    for (const m of items) {
      if (m.id != item.id && m.name.indexOf(item.name) > -1) {
        exists = true;
        const arr = m.name.split(" ");
        if (arr && arr.length) {
          let last = arr[arr.length - 1];
          const nr = parseInt(last);
          if (nr > max) max = nr;
        }
      }
    }
    if (!exists) return item.name;
    else return item.name + " " + (max + 1);
  }

  async addFolderTo(folder:IFolder) {
    if (!this.store) return;
    let parent_id: string | undefined = undefined
    if (folder) parent_id = folder.id

    const item: IFolder = {
      id: "",
      parent_id: parent_id,
      user: bus.get_user(),
      name: "Nowy",
      ctx:{},
      type: FolderType,
      version: 0,
      selected:false,
      prompt: "",
      system:false
    };

    item.selected = true
    const ret = await this.store.saveFolder(item);
    if (ret) await this.refresh();

  }


  async delFolder(item: IFolder) {
    if (!this.store) return;
    if (!this.items) return;
    if (!confirm("Skasować folder "+item.name+"?")) return;
    const ret = await this.store.deleteFolder(item);
    console.log(ret)
    this.items = await this.store.getFoldersForParentId(
      this.parent_id,
      bus.get_user()
    );
    this.key++;
  }

  async delBot(bot:IBot, event:MouseEvent) {
    event.preventDefault()
    event.stopPropagation()
    if (!this.store) return;
    //if (!confirm("Skasować bota?")) return;

    await this.store.deleteBot(bot);
    this.bots=this.bots.filter( b => b.id != bot.id)
    this.bots_key++
    //if (this.prefresh) await this.prefresh()
  }

  async saveFolder(item: IFolder) {
    if (!this.store) return;
    if (!this.items) return;

    item.name = this.get_next_name(item, this.items);

    const ret = await this.store.saveFolder(item);
    if (ret) await this.refresh();
  }

  async selectFolder(item: IFolder | undefined) {
    if (!this.store) return;
    if (!item) return;
    item.selected=!item.selected;
    const ret = await this.store.saveFolder(item);
    if (this.items) this.key++;
  }

  async on_saved() {
    await this.refresh()
  }

  async refresh() {

    this.bot_keys={}
    if (!this.store) return;
    this.can_see_code = bus.get_user()._id == "MANPROC1";
    this.key = 0;
    const user: IUser = bus.get_user();
    this.username = user.data_username
  
    if (this.folder?.expandedIndex)
    this.expandedIndex = this.folder?.expandedIndex

    this.items = await this.store.getFoldersForParentId(
      this.parent_id,
      bus.get_user()
    );
  
    this.ctx = {}
    
    const bots = await this.store.getBotsForParentId(
      this.parent_id,
      bus.get_user()
    )
    


    for (const b of bots) {
      if (b.id) this.bot_keys[b.id] = 1
    }

    //let maxx=0
    let maxy=0
    for (const b of bots) {
      //if (b.x && b.x>maxx) maxx=b.x;
      b.x=this.bot_left
      if (b.y && b.y>maxy) maxy=b.y;
    }
    //maxx+=100;
    maxy+=100;

    const step=100
    for (const b of bots) {
      /*
      if (!b.x) {
        b.x=maxx
        maxx+=step
      }
      */
      if (!b.y) {
        b.y=maxy
        maxy+=step
      }
    }

    //this.precompiled_bots = bots.filter( b => b.type == botPrecompiledType)
    this.bots = bots.filter(b => b.type == botType)
    this.precompiled_bots = bots.filter(b => b.type != botType)
    //this.adjustAllTextareaHeights();
    if (this.items || this.bots || this.ctx) this.key++;
  }

  async converterCreated(conv:any) {
    console.log("converterCreated",conv)
  }

  async botCreated(bot:any) {
    console.log("botCreated",bot)
  }
 
  async createBot(folder: IFolder) {
    if (!folder.prompt) { 
      alert("wpisz zadanie dla asystenta")
      return;
    }
    
    const new_bot = await bus.api("/api/ai/createBot", { instrukcja:folder.prompt, use_bots: this.folder?.use_bots, parent_id:folder.id, ctx: folder.ctx } );
    
    this.bots = [...this.bots, new_bot]
    this.bots_key++
    //await this.refresh()
  }
  

  adjustAllTextareaHeights() {
      console.log("adjust ")
      this.$nextTick(() => {
        const textareas = this.$el.querySelectorAll('textarea');

        textareas.forEach(textarea => {
          textarea.style.height = 'auto';
          textarea.style.height = textarea.scrollHeight + 'px';
        });
      });
    }
  
  

  async pasteSelectedBot(parent_folder_id:string, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dm.reset(typeSelectBot)
/*
    const bot = this.dm.get(typeSelectBot)
    if (!bot) return;

    if (!confirm("Dodać bota "+bot.function_call+" do tego folderu?")) {
      this.dm.reset(typeSelectBot)
      return;
    }

    let maxy=0
    for (const b of this.bots) {
      if (b.y && b.y>maxy) maxy=b.y;
    }
    maxy+=50

    if (bot.type == botPrecompiledType) {
      const new_bot = await this.store.copyBot(bot, parent_folder_id,bot.x,maxy, true)
      Vue.set(this.bots, this.bots.length, new_bot);
    } else {
      const new_bot = await this.store.copyBot(bot, parent_folder_id,bot.x,maxy, false)
      Vue.set(this.bots, this.bots.length, new_bot);
    }

    this.dm.reset(typeSelectBot)
    
    //await this.refresh()
*/    
  }

  async handlePromptKeydown(event: MouseEvent) {
    if (!this.folder) return;
    const bot = this.dm.get(typeSelectBot)
    if (bot) {
      this.folder.prompt = bot.prompt
      this.prompt_key++
        this.dm.reset(typeSelectBot)
        this.dm.reset(typeMoveParam)
        this.dm.reset(typeMoveObj)
        this.dm.reset(typeCtxParam)
        this.dm.hide_tooltip()
    } 

    const param= this.dm.get(typeCtxParam)
    if (param) { 
      console.log(param)
      this.folder.prompt = this.folder.prompt +" "+param.key+' {'+param.key+'} '
      this.dm.reset(typeCtxParam)
      this.dm.hide_tooltip()
      this.prompt_key++
    }

    console.log('handlePromptKeydown end')
  }

  async handleMouseDown(bot: IBot,parent_id: string, event:MouseEvent, left_pan?:number) {
      console.log("******************* handleMouseDown")
      event.preventDefault()
      event.stopPropagation()

      if (!bot) {

        if (this.dm.get(typeSelectBot) ) {
          await this.pasteSelectedBot(parent_id, event)
        }
      
        this.dm.reset(typeSelectBot)
        this.dm.reset(typeMoveParam)
        this.dm.reset(typeMoveObj)

        this.dm.hide_tooltip()
        return;

      }

      

      if ((event.button === 2)) {
        console.log()
        this.dm.set(bot, typeSelectBot)
        this.dm.show_tooltip(bot.function_name, event.clientX-10, event.clientY+10 )
        return;
      } else {
        
        this.dm.set(bot,typeMoveBot)
        this.lastMousePos.x = event.clientX; // Corrected assignment
        this.lastMousePos.y = event.clientY; // Corrected assignment
      }

  }


  async handleMouseMove(event: MouseEvent) {
    
    if (this.dm.get(typeSelectBot) || this.dm.get(typeMoveParam)|| this.dm.get(typeMoveObj) || this.dm.get(typeDatasourceParam )) {
      this.dm.move_tooltip( event.clientX+30, event.clientY+10 )
      return;
    }

    if (event.button === 0) {
      
      const bot:IBot = this.dm.get(typeMoveBot)
      if (!bot) return;

      if (!bot.x) bot.x=0
      if (!bot.y) bot.y=0;
      const deltaX = event.clientX - this.lastMousePos.x;
      const deltaY = event.clientY - this.lastMousePos.y;

      //bot.x += deltaX;
      bot.x = this.bot_left
      bot.y += deltaY;

      this.lastMousePos.x = event.clientX;
      this.lastMousePos.y = event.clientY;
    } 
  }
  
  async handleMouseUp(bot:IBot, event:MouseEvent) {
    
    event.preventDefault()
    event.stopPropagation();
    
    const moving_bot:IBot = this.dm.get(typeMoveBot)
    if (moving_bot) {
      
      this.dm.reset(typeMoveBot)    
      this.dm.hide_tooltip()
      console.log("handleMouseUp", moving_bot)

      if (!(moving_bot.type===botPrecompiledType)) {
      
        await bus.api("/api/ai/bot/save", { obj: moving_bot } );

        console.log("handleMouseUp end", moving_bot)
        this.key++
      }

    }

  
  }
  
  async runBots(bots:IBot[]) {
    if (!this.folder) return;
    this.ctx_key=0;
    const new_ctx = await bus.api("/api/ai/runBots", { module:'main', bots: bots, ctx: this.folder?.ctx} );
    console.log(new_ctx)
    if (new_ctx) {
      this.folder.ctx = new_ctx
      const ret = await this.store.saveFolder(this.folder);
      if (ret) this.ctx_key++;
    }
  }

  async run_bot(bot:IBot) {
    const bots=[bot]
    return await this.runBots(bots)
  }

  get_bot_key(bot: IBot) {
    if (!bot) return 1;
    if (!bot.id) return 1;
    return (bot.id+'_'+this.bot_keys[bot.id])
  }
  
  async on_hilight_bot(bot:IBot) {
    if (!bot) return;
    if (!bot.id) return;
/*
    for (let i=0;i<this.bots.length;i++) {
      if (this.bots[i].id===bot.id) {
        await this.toggleExpanded(i)
      }
    }
*/    
  }

  async toggleExpanded(index: number) {
    console.log("toggleExpanded", index)
    this.expandedIndex = index
    if (this.folder) {
      this.folder.expandedIndex = index
      const ret = await this.store.saveFolder(this.folder);
      console.log("toggleExpanded saved")
    }
    this.key++
  }

  bot_zindex(index: number): number {
    if (!this.folder) return 300;
    if (this.folder.expandedIndex==null) return 300;
    return 300+50*(this.folder.expandedIndex === index ? 1 : 0);
  }

  async on_bot_mouse_down(e:any) {
    console.log("on_bot_mouse_down")
    this.handleMouseDown(e.bot, e.parent_id, e.event, e.left_pan)
  }

  async on_bot_mouse_up(e:any) {
    console.log("on_bot_mouse_up")
    this.handleMouseUp(e.bot, e.event)
  }

  async on_bot_del(e:any) {
    console.log("on_bot_del")
    this.delBot(e.bot, e.event)
  }
  
  none(event:MouseEvent) {
    console.log("none")
    event.preventDefault()
    event.stopPropagation()
  }

  async use_bots_clicked(folder:IFolder) {
    await this.createBot(folder)
    //const ret = await this.store.saveFolder(folder);
  }

  async prompt_changed(folder:IFolder) {
    const ret = await this.store.saveFolder(folder);
  }

  async ctx_changed(folder:IFolder) {
    const ret = await this.store.saveFolder(folder);
  }

  format_username(first_last:string) {
    const arr=first_last.split(" ")
    const first:string=arr[0]? arr[0] : ""
    const last:string=arr[1]? arr[1] : ""
    const initial=first.charAt(0) ?first.charAt(0):""
    return initial+". "+last
  }

}
